import React from 'react';
import Title from '../../uiKit/typography/title';
import Paragraph from '../../uiKit/typography/paragraph';
import { useTranslation } from 'react-i18next';

export default function OverviewBlock({ text }) {
  const { t } = useTranslation('common');

  return (
    <div className={'w-full flex flex-col gap-4'}>
      <div className={'flex items-center justify-center md:justify-start'}>
        <Title className={'text-2xl md:text-3xl'}>
          {t('titles.overview')}
        </Title>
      </div>

      <Paragraph className={'text-xl leading-7 md:leading-8'}>
        {text}
      </Paragraph>
    </div>
  );
}
